import { doc, getDoc } from "firebase/firestore";
import { getAllCashflowEntries } from "../FirebaseHelpers/FirebaseHelpers"; //  adjust the import!
import { firestore as db } from "../../../../backend/firebaseconfig";
import dayjs from "dayjs";

/**
 * Fetch Cashflow Modeller clients for a single user.
 * Enriches each client with:
 *   - Client ID
 *   - Client name (first 2 names joined)
 *   - Creation date
 *   - CreatedBy (email)
 *   - Trading name
 *   - Primary color
 *
 * @param {string} role - User's role.
 * @param {string} email - User's email.
 * @returns {Promise<Array>} Array of enriched client objects.
 */
export const getCashflowClientsForUser = async (role, email) => {
  if (!role || !email) return [];

  // Get all entries under this user
  const entries = await getAllCashflowEntries(role, email);

  // Fetch user's meta (trading name, branding)
  const parentRef = doc(db, "Authorized Members", role, "Data", email);
  const parentSnap = await getDoc(parentRef);
  const parentData = parentSnap.exists() ? parentSnap.data() : {};
    const normBool = (v) => v === true || v === "true" || v === 1 || v === "1";

  // Enrich
  const formatted = entries.map((entry) => ({
    id: entry.uid,
    role,
    name:
      entry.details && Array.isArray(entry.details)
        ? entry.details
            .slice(0, 2)
            .map((d) => d.name)
            .filter(Boolean)
            .join(" & ") || "Unnamed Client"
        : "Unnamed Client",
    rawDate: entry.createdAt || null,
    date: entry.createdAt
      ? dayjs(entry.createdAt).format("DD/MM/YYYY")
      : "Unknown",
    createdBy: email,
    updatedOn: entry.updatedOn
      ? dayjs(entry.updatedOn).format("DD/MM/YYYY")
      : "",
    tradingName:
      parentData.tradingName || "Rosemount Financial Solutions (IFA) Ltd",
    primaryColor: parentData.primaryColor || "081e56",
    isScenario: normBool(entry?.isScenario),
    parentDocId: entry?.parentDocId || "",
    scenarios: Array.isArray(entry?.scenarios)
      ? entry.scenarios
          .map((s) => ({ id: s?.id, name: s?.name }))
          .filter((s) => !!s.id)
      : [],
  }));

  // Sort
  return formatted.sort((a, b) => {
    const dateA = a.rawDate ? new Date(a.rawDate).getTime() : 0;
    const dateB = b.rawDate ? new Date(b.rawDate).getTime() : 0;
    return dateB - dateA;
  });
};
